export default "__VITE_ASSET__DwAzxtdu__"